import React from "react"
import Testimonial from "./testimonial.module.scss"
import text from "../styles/typography.module.scss"

export default function testimonial(props) {
  return (
    <div className={Testimonial.container}>
      <div className={Testimonial.wrapper}>
        <div className={Testimonial.parent}>
          <p className={text.paragraph}>{props.text}</p>
          <img src={props.image} alt={props.alt}></img>
          <h3 className={text.heading3}>{props.name}</h3>
          <h4 className={text.heading4}>{props.job}</h4>
        </div>
      </div>
    </div>
  )
}
